import { AxiosInstance } from "axios";
import { logger } from "@platform/browser-logger";

import { CarrierRepDirectoryCarrierResponse } from "./types";

const BP_API_BASE_URL = "/bp/v1/carrier-rep-directory";

export const listCarriers = async (
  axiosInstance: AxiosInstance,
): Promise<CarrierRepDirectoryCarrierResponse[]> => {
  const response = await axiosInstance.get<
    CarrierRepDirectoryCarrierResponse[]
  >(`${BP_API_BASE_URL}/carriers`);

  logger.debug("[Carriers Rep Directory API] Carriers listed:", {
    carrierIds: response.data.map((carrier) => carrier.id),
  });

  return response.data;
};
